// cSpell:locale en pt-BR
// cSpell:ignore muuito

const PtBR = {
  name: "Garçom Digital",
  description: "Mais sabor para o seu negócio",
  table: "Mesa",
  command: "Comanda",
  promotion: "Promoções",
  feedback: "Avaliação",
  noneFound: "Nada foi encontrado!",
  tryRemoveFilter: "Tente remover um filtro",
  priceFrom: "A partir de",
  subtotal: "SubTotal",
  total: "Total",
  paidOut: "Pago",
  totalToPay: "Valor a pagar",
  serviceTax: "Serviços",
  optional: "Opcional",
  additions: "Acréscimo",
  discount: "Desconto",
  details: "Detalhes",
  about: "Sobre a POP Pedidos",
  qrScanner: {
    scanner: "Scanner",
    search: "Buscar",
    installApp: "Instalar Garçom Digital",
    scanAnotherCode: "Escanear outro código",
    cannotAccessCamera: "Não foi possível acessar a câmera",
    enterQrCode: "Digite abaixo o código da mesa, ele fica embaixo do QR Code!",
    enterCommandQrCode: "Digite abaixo o código da comanda, ele fica embaixo do QR Code!",
    requiredCameraPermission: "Requer acesso à câmera",
    requireCameraPermission:
      "Para escanear o QR Code, permita que o Garçom Digital acesse a câmera",
    manualQrCode: "Digitar o código manualmente",
    readQrCodeToAccess: (
      <>
        Para acessar aponte a camera para o QR Code <b>da mesa</b>
      </>
    ),
    readCommandQrCodeToAccess: (
      <>
        Aponte a camera para o QR Code <b>da sua comanda</b>
      </>
    ),
    cannotAccessTablet: "Você não possui acesso a tablets do Garçom Digital",
    needInstallApp: (
      <>
        Você está utilizando o Garçom Digital no modo <b>Tablet na Mesa</b>,
        <br />
        para desfrutar de toda as funcionalidades é <b>necessário</b> a instalação do
        nosso aplicativo!
      </>
    ),
  },
  modal: {
    success: "Sucesso!",
    thanks: "Obrigado!",
    okThanks: "Ok, obrigado!",
    close: "Fechar",
    save: "Salvar",
    back: "Voltar",
    confirm: "Confirmar",
    notNow: "Agora não",
    waiter: {
      extraCup: "Copo extra",
      cupWithIce: "Copo com gelo",
      extraCutlery: "Talher extra",
      extraDish: "Prato extra",
      clearTable: "Limpar mesa",
      anotherReasons: "Outros motivos",
      callNow: "Chamar agora",
      callWaiter: "Chamar garçom",
      rateLimit: "Aguarde um pouco,\nvocê está chamando o garçom muito rápido!",
      called: (
        <>
          O garçom foi chamado,
          <br />
          iremos te atender em alguns instantes!
        </>
      ),
    },
    language: {
      title: "Alterar idioma",
      confirm: "Confirmar",
      portuguese: "Português",
      brazil: "Brasil",
      english: "Inglês",
      unitedStates: "Estados Unidos",
      spanish: "Espanhol",
      spain: "Espanha",
    },
    account: {
      title: "Minha conta",
      empty: "Nada ainda na sua conta!",
      splitBillQuestion: "Vai dividir a conta?",
      personsNumbers: "Nº de pessoas",
      valuePerPerson: "Valor por pessoa",
      requestAccount: "Pedir conta",
    },
    cart: {
      title: "Carrinho de compras",
      empty: "Carrinho Vazio!",
      sendOrder: "Fazer Pedido",
      orderPaused: "Mesa pausada",
      orderSended: (
        <>
          O seu pedido foi registrado!
          <br />
          <br />
          Para saber mais sobre os seus pedidos utilize a opção &quot;Minha Conta&quot;
          <br />
          <br />
          Em caso de duvidas fique a vontade para chamar o garçom ✨
        </>
      ),
      belongsAnother: "Essa código pertence a outra mesa",
    },
    feedback: {
      title: "Avaliação",
      thanks:
        "Sucesso! Agradecemos por você dedicar um tempo para nos dar uma avaliação!",
      didYouThink: "O que você achou do nosso serviço?",
      opinionImportant: "Sua opinião é muito importante, deixe sua avaliação abaixo!",
      yourName: "Seu nome",
      whatMainReason: "Quais são os principais motivos da sua classificação?",
      required:
        "Você precisa avaliar todas as opções para enviar sua avaliação, os campos nome e mensagem são opcionais.",
      send: "Enviar Avaliação",
    },
    poweredBy: {
      title: (
        <>
          O garçom digital que irá <b>impressionar</b> os seus clientes
        </>
      ),
      ordersOnTable: "Pedidos na mesa",
      selfService: "Autoatendimento",
      innovationAndTechnology: "Inovação e tecnologia",
      andMuchMore: (
        <>
          E <b>muuito</b> mais!
        </>
      ),
    },
    product: {
      close: "Fechar produto",
      next: "Avançar",
      update: "Atualizar",
      add: "Adicionar",
      anyObservation: "Alguma observação?",
      observationExample: "Exemplo: Tirar a cebola e o tomate, maionese a parte, etc.",
      unavailable: "Indisponível neste horário",
      quantity: "Quantidade",
      quantityAndObservation: "Quantidade e observação",
      select: "Selecione",
      flavor: "Sabor",
      or: "ou",
      to: "a",
      option: "opção",
      options: "opções",
      until: "até",
    },
    qrCodeConfirm: {
      title: "Confirmação de mesa",
      titleCommand: "Confirmação de comanda",
    },
    setupTable: {
      title: "Número da mesa",
      message: "Informe abaixo o número da sua mesa:",
    },
    confirmOrder: {
      title: "Confirmar o envio do pedido?",
      message:
        "Ao confirmar, seu pedido será enviado e não poderá ser alterado ou cancelado.",
    },
    table: {
      restrictArea: "Área Restrita",
      title: "Opções da mesa",
      mode: "Modo de operação",
      typePassword: "Digite a senha",
      tableNumber: "Número da mesa",
      requestTableNumberInput: "Pedir",
      reduceMotion: "Reduzir animações e efeitos",
      autoBrightness: "Brilho automático",
      clearTable: "Limpar mesa",
      clearAndCloseTable: "Limpar e fechar mesa",
      signOut: "Sair do Garçom Digital",
      integrated: "Esta mesa está integrada!",
      signOutConfirm: "Clique novamente para sair",
      buffet: "Rodízio",
    },
    installApp: {
      appName: "Garçom Digital",
      configure: "Configurar",
      configureHomeScreen: (
        <>
          Você está no modo <b>Tablet na Mesa</b>, para uma melhor experiencia
          <b> recomendamos</b> definir o Garçom Digital como um aplicativo
          <b> padrão de tela inicial</b>!
        </>
      ),
    },
    deviceNotAuthorized: {
      title: "Não Autorizado!",
      message: "Você foi desconectado.",
    },
    orderPaused: {
      title: "Mesa em recebimento!",
      message: "Você não pode realizar pedidos enquanto a mesa estiver em recebimento.",
    },
  },
  error: {
    pageNotFound: "Esta página não foi encontrada",
    unexpectedError: "Ocorreu um erro inesperado",
    serverError: "Ocorreu um erro no servidor",
    clientError: "Erro de aplicativo: ocorreu uma exceção do lado do cliente",
  },
};

export default PtBR;
